/**************************************************
 * Nombre:       Dialogo_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Checkbox, FormControlLabel, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Contacto from "../Formularios/Formulario_Contacto";
import {Check} from '@mui/icons-material'
import {useState} from "react";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'

const Dialogo_Informacion = ({datos, cerrar}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos});
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({logoRedondo: logo, funcionUno: cerrar})
    const [acepato, setAacepato] = useState(true);

    const enviar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Cargando Datos')
        entidad.estado = 'Nuevo'
        entidad.celular = limpiarCelular(entidad.celular)

        let dox = await guardarDoc('potenciales', entidad)
        if (dox.res) {
            terminar({aviso: 'Formulario enviado con exito, pronto nos contactaremos contigo'})
        } else {
            terminar({aviso: 'Ups, algo ocurrio, intentalo nuevamente', variante: 'error'})
        }


    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                p: 1
            }}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Contacto props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 1}}>
                <FormControlLabel control={<Checkbox defaultChecked onChange={() => setAacepato(!acepato)}/>}
                                  label="Acepto politica de tratamiento de datos"/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 1}}>
                <Button
                    onClick={() => enviar()}
                    disabled={!acepato}
                    sx={{px: 6}}
                    startIcon={<Check/>}>Enviar</Button>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Informacion